import { NotificationId } from '@gyym/sdk'

import { isLocalStorageAvailable } from '@/utils/isLocalStorageAvailable'

import { NOTIFICATIONS_READ_KEY } from './constants'

export const markNotificationsAsRead = async (
  notificationIds: NotificationId[],
) => {
  // localStorageが利用できない場合は何もしない
  if (!isLocalStorageAvailable()) return

  try {
    const readNotificationIds = JSON.parse(
      localStorage.getItem(NOTIFICATIONS_READ_KEY) || '[]',
    )

    localStorage.setItem(
      NOTIFICATIONS_READ_KEY,
      JSON.stringify([
        // Uniqueにしてセット
        ...Array.from(new Set([...readNotificationIds, ...notificationIds])),
      ]),
    )
  } catch {
    try {
      localStorage.setItem(
        NOTIFICATIONS_READ_KEY,
        JSON.stringify(notificationIds),
      )
    } catch {
      return
    }
    return
  }
}

export const getUnreadNotificationCount = (
  notificationIds: NotificationId[],
) => {
  // localStorageが利用できない場合は0を返す
  if (!isLocalStorageAvailable()) return 0

  try {
    const readNotificationIds = JSON.parse(
      localStorage.getItem(NOTIFICATIONS_READ_KEY) || '[]',
    )

    return notificationIds.filter((id) => !readNotificationIds.includes(id))
      .length
  } catch {
    return 0
  }
}
